var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompactTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#020203;}\r\n\t.st5{fill:none;}\r\n\t.st6{display:inline;opacity:0.3;}\r\n\t.st7{fill:#616160;}\r\n\t.st8{fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st9{display:inline;fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st10{display:inline;fill:none;stroke:#616160;}\r\n\t.st11{display:inline;fill:#616160;}\r\n\t.st12{display:none;opacity:0.5;}\r\n\t.st13{display:inline;opacity:0.58;}\r\n\t.st14{fill:#010202;}\r\n\t.st15{fill:#F0F0F0;}\r\n\t.st16{fill:#1F70B7;}\r\n\t.st17{fill:none;stroke:#C4C4C4;stroke-width:0.5;}\r\n\t.st18{fill:#2470B7;}\r\n\t.st19{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st20{fill:none;stroke:#B4B0B0;stroke-width:0.5;}\r\n\t.st21{fill:#C4C4C4;}\r\n\t.st22{fill:none;stroke:#C4C4C4;stroke-width:2;}\r\n\t.st23{fill:#1D70B8;}\r\n\t.st24{fill:none;stroke:#1D70B8;stroke-width:2;}\r\n\t.st25{fill:none;stroke:#1D70B8;}\r\n\t.st26{fill:none;stroke:#1D70B8;stroke-width:3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Editabl",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.0034,2.708H1.9966c-0.5513,0-1,0.4482-1,1v3.127v0.9805v4.4766c0,0.5518,0.4272,1,0.9526,1h3.3574H6.332 h7.6421c0.5674,0,1.0293-0.4482,1.0293-1V7.8154V6.835V3.708C15.0034,3.1562,14.5547,2.708,14.0034,2.708z M14.0034,3.708v3.1074 H8.4556V3.708H14.0034z M1.9966,3.708h5.459v3.1074h-5.459V3.708z M1.9966,12.292V7.835h3.3101v4.457H1.9966z M6.332,7.835h3.6265 v4.457H6.332V7.835z M13.9741,12.292h-3.0156V7.835h3.042L13.9741,12.292z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactTheme);
export default __webpack_public_path__ + "static/media/CompactTheme.f08f1e7bd019bcc1faf9662b03fd958b.svg";
export { ForwardRef as ReactComponent };